import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { myHeaders } from "./CommonHeader";

export const ConfirmedOrder = createAsyncThunk(
  "ConfirmedOrder",
  async (data1, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        process.env.REACT_APP_BackEndIP+"/ConfirmedOrder",
        {
          Confirm:"YesYesYes",
        },
        {
          headers: myHeaders(),
        }
      );
      return data;
    } catch (error) {
      console.error("!!!", error);
      if (error?.response?.status > 399 || error.code === "ERR_NETWORK") {
        localStorage.clear();
        window.location.assign("/");
      }
    }
  }
);

const ConfirmOrderSlice = createSlice({
  name: "ConfirmOrder",
  initialState: {
    isLoading: false,
    isSuccess: false,
    data:null,
  },  reducers: {
    ResetConfirmOrderAction(state, action) {
        state.isLoading=false;
        state.isSuccess=false;
        state.data=null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(ConfirmedOrder.fulfilled, (state, action) => {
        state.isLoading=false;
        state.isSuccess=true;
        state.data=action.payload;
      })
      .addCase(ConfirmedOrder.pending, (state, action) => {
        state.isLoading=true;
        state.isSuccess=false;
        // if action error then display that error
      })
     
  },
});
export const {ResetConfirmOrderAction} = ConfirmOrderSlice.actions;
export default ConfirmOrderSlice.reducer;
